<template>
    <div class="flex flex-col">
        
        <div class="" :class="phoneScreen.landscape && 'px-2' || 'p-3'">
            <div class="w-full bg-white  rounded-full mb-2" :class="phoneScreen.landscape && 'h-2 lg:h-4' || 'h-4'">
                <div class="games-elements-secondary-gridant rounded-full" :style="`width: ${getFirstGamePercent}%`"
                    :class="phoneScreen.landscape && 'h-2 lg:h-4' || 'h-4'"
                ></div>
            </div>
        </div>

        <div class="flex justify-between px-4 text-black">
            <div class="flex flex-col">
                <div :class="phoneScreen.landscape && 'text-2xs'" >&nbsp; </div>
                <div :class="phoneScreen.landscape && 'text-sm lg:text-2xl' || 'text-xl lg:text-2xl'" class="font-bold games-elements-text-color-secondery">
                    {{gamer[0]?.point}} {{ $t('elements_title_point') }}
                </div>
            </div>
            
            <div class="font-bold" :class="phoneScreen.landscape && 'text-2xl lg:text-5xl' || 'text-4xl lg:text-5xl'" >
                {{current_time}}
            </div>
            <div class="flex flex-col text-right">
                <div :class="phoneScreen.landscape && 'text-sm lg:text-xl' || 'text-sm lg:text-xl'" class="text-white"  >{{ $t('elements_title_record') }}</div>
                <div :class="phoneScreen.landscape && 'text-sm lg:text-2xl' || 'text-xl lg:text-2xl'" class="font-bold games-elements-text-color-secondery">
                    {{store_point > gamer[0]?.point ? store_point : gamer[0]?.point}} {{ $t('elements_title_point') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue"
import {useScreen} from 'vue-screen'

const phoneScreen = useScreen()
const props = defineProps(['gamer', 'store_point', 'current_time'])

const getFirstGamePercent = computed(() => {
    const allPoint = props.store_point > props.gamer[0]?.point ? props.store_point : props.gamer[0]?.point
    const points   = props.gamer[0]?.point;

    return (100 * points) / allPoint;
})
</script>
